import { render } from "./SeleccionDocumentos.vue?vue&type=template&id=ff622a6a&scoped=true"
import script from "./SeleccionDocumentos.vue?vue&type=script&lang=js"
export * from "./SeleccionDocumentos.vue?vue&type=script&lang=js"

import "./SeleccionDocumentos.vue?vue&type=style&index=0&id=ff622a6a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff622a6a"]])

export default __exports__